import React from 'react';

const HelpIcon = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Outer circle with a gray-like stroke (uses currentColor by default) */}
      <circle
        cx="10"
        cy="10"
        r="9"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      {/* Question mark in the center, also using currentColor */}
      <path
        d="M10 5c-1.1 0-2 .9-2 2h1.2c0-.66.54-1.2 1.2-1.2s1.2.54 1.2 1.2c0 .28-.11.52-.29.71l-1.23 1.22c-.48.48-.78 1.11-.78 1.8v1.27h1.2v-1.27c0-.28.11-.52.29-.71l1.23-1.22C12.48 7.8 13 6.95 13 6c0-1.66-1.34-3-3-3zm-.6 8.2h1.2v1.2h-1.2v-1.2z"
        fill="currentColor"
      />
    </svg>
  );
};

export default HelpIcon;
